import { createSlice } from "@reduxjs/toolkit";
import {
  AUTH_BOOTSTRAP_START,
  AUTH_BOOTSTRAP_SUCCESS,
  AUTH_BOOTSTRAP_FAILURE,
} from "state/types/actionTypes";

const initial = {
  isAuthenticated: false,
  user: null,
  checked: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initial,
  reducers: {
    // payload: { isAuthenticated: boolean, user: object|null }
    setAuth(state, { payload }) {
      state.isAuthenticated = !!payload?.isAuthenticated;
      state.user = payload?.user || null;
      state.error = null;
    },
    setChecked(state, { payload }) {
      state.checked = payload ?? true;
    },
    clearAuth(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.checked = true; // we’ve determined auth state
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AUTH_BOOTSTRAP_START, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AUTH_BOOTSTRAP_SUCCESS, (state) => {
        state.loading = false;
      })
      .addCase(AUTH_BOOTSTRAP_FAILURE, (state, { payload }) => {
        state.loading = false;
        state.error = payload || null;
      });
  },
});

export const { setAuth, setChecked, clearAuth } = authSlice.actions;
export const authReducer = authSlice.reducer;
